import * as tf from '@tensorflow/tfjs';
import Encoder from './encoder';

/* LeelaZero inputs
    1) Side to move stones at time T=0
    2) Side to move stones at time T=-1  (0 if T=0)
    ...
    8) Side to move stones at time T=-7  (0 if T<=6)
    9) Other side stones at time T=0
    10) Other side stones at time T=-1   (0 if T=0)
    ...
    16) Other side stones at time T=-7   (0 if T<=6)
    17) All 1 if black is to move, 0 otherwise
    18) All 1 if white is to move, 0 otherwise
*/

class LeelaZeroEncoder extends Encoder {
  static MY_STONES_LAYER = 0;
  static OTHER_STONES_LAYER = 8;
  static BLACK_IS_NEXT_LAYER = 16;
  static WHITE_IS_NEXT_LAYER = 17;
  static N_LAYERS = 18; // number of layers

  encode(history) {    
    let boardModel = history.pop();
    const blackIsNext = boardModel.blackIsNext;
    const boardSize = boardModel.boardSize;
    const blackTensors = [];
    const whiteTensors = [];
    for (let i = 0; i < 8; i++) {
      if (history.length) {
        if (i > 0) {
          boardModel = history.pop();
        }
        const [b, w] = this.encodeBoardModel(boardModel);
        blackTensors.push(b);
        whiteTensors.push(w);
      } else {
        blackTensors.push(tf.zeros([boardSize, boardSize]));
        whiteTensors.push(tf.zeros([boardSize, boardSize]));
      }
    }

    const layers = [];
    for (let i = LeelaZeroEncoder.MY_STONES_LAYER; i <= LeelaZeroEncoder.N_LAYERS; i++) {
      if (i < LeelaZeroEncoder.OTHER_STONES_LAYER) {
        layers.push(blackIsNext ? blackTensors[i] : whiteTensors[i]);
      } else if (i < LeelaZeroEncoder.BLACK_IS_NEXT_LAYER) {
        layers.push(blackIsNext ? whiteTensors[i - LeelaZeroEncoder.OTHER_STONES_LAYER]
          : blackTensors[i - LeelaZeroEncoder.OTHER_STONES_LAYER]);
      } else if (i === LeelaZeroEncoder.BLACK_IS_NEXT_LAYER) {
        layers.push(blackIsNext ? tf.ones([boardSize, boardSize]) : tf.zeros([boardSize, boardSize]));
      } else if (i === LeelaZeroEncoder.WHITE_IS_NEXT_LAYER) {
        layers.push(blackIsNext ? tf.zeros([boardSize, boardSize]) : tf.ones([boardSize, boardSize]));
      }
    }
    const encoded = tf.transpose(tf.stack(layers), [1, 2, 0]);
    // this.dump_board(encoded);
    return encoded;
  }

  // dump_board(board) {
  //   board = tf.transpose(board, [2, 0, 1]); // [19, 19, 18] to [18, 19, 19]
  //   console.log("board: " + board.shape + " " + board.dtype)
  //   console.log('My stone:');  
  //   tf.slice(board, LeelaZeroEncoder.MY_STONES_LAYER, 1).squeeze().print();
  //   console.log('Other stone:');  
  //   tf.slice(board, LeelaZeroEncoder.OTHER_STONES_LAYER, 1).squeeze().print();
  //   console.log('Black to move:');  
  //   tf.slice(board, LeelaZeroEncoder.BLACK_IS_NEXT_LAYER, 1).squeeze().print();
  //   console.log('White to move:');  
  //   tf.slice(board, LeelaZeroEncoder.WHITE_IS_NEXT_LAYER, 1).squeeze().print();
  // }

}

export default LeelaZeroEncoder;